import React from 'react';
import {Trans} from 'react-i18next';
import Select from 'react-select';
import {deviceOptions} from '../../config/utils/optionsUtils';
import storeUtils from '../../../../../utils/storeUtils';
import _get from 'lodash/get';
import {Field} from 'formik';
import {useSelector} from 'react-redux';
import smbUtils from '../../../../../utils/smbUtils';
import CustomSwitch from '../../../../../components/layout/CustomSwitch';
import ImageField from '../../../../../components/formik/ImageField';
import {treatmentTypes} from '../../../../../utils/skincareUtils';
import langUtils from '../../../../../utils/langUtils';
import TextareaBox from '../../../../../components/formik/TextareaBox';

export default function SimulationReportGenericLayoutSetting({
  formikProps,
  device,
  setDevice,
  treatment,
  setTreatment,
  language,
  setLanguage,
}) {
  const auth = useSelector(state => state.components.auth.accountSummary);
  const {customerId} = smbUtils.customerInfo(auth);
  return (
    <>
      <h5>
        <Trans i18nKey="p.s.uiconfiguration.simulationreport.report.banner">
          Report Banner
        </Trans>
        <div
          className="kt-margin-t-10"
          style={{
            backgroundColor: '#e1e1ef',
            height: '1px',
          }}
        />
      </h5>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.simulationreport.show.banner">
            Show Banner
          </Trans>
        </label>
        <div className="col-9 col-lg-8 col-md-8 m-auto">
          <Field
            name="simulationResultPage.reportBanner.showBanner"
            value={_get(
              formikProps.values,
              'simulationResultPage.reportBanner.showBanner'
            )}
            component={CustomSwitch}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.simulationreport.main.image">
            Main Image
          </Trans>
        </label>
        <div className="col-5">
          <Select
            options={deviceOptions}
            onChange={o => {
              storeUtils.setUiConfigSettingDevice(customerId, _get(o, 'value'));
              setDevice(o);
            }}
            value={device}
            isSearchable={false}
            isClearable={false}
            placeholder={
              <Trans i18nKey="c.c.select.placeholder">Select...</Trans>
            }
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4" />
        <div className="col-4">
          {device.value === 'pad' && (
            <Field
              name="simulationResultPage.reportBanner.mainImage[1].imageFile"
              imageUrl={_get(
                formikProps.values,
                'simulationResultPage.reportBanner.mainImage[1].imageUrl'
              )}
              scaleImage={true}
              clearFormFields={[
                'simulationResultPage.reportBanner.mainImage[1].imageUrl',
                'simulationResultPage.reportBanner.mainImage[1].imageFile',
              ]}
              component={ImageField}
              width={2880}
              height={632}
              maxWidth={480}
              maxHeight={106}
            />
          )}
          {device.value === 'mobile' && (
            <Field
              name="simulationResultPage.reportBanner.mainImage[0].imageFile"
              imageUrl={_get(
                formikProps.values,
                'simulationResultPage.reportBanner.mainImage[0].imageUrl'
              )}
              scaleImage={true}
              clearFormFields={[
                'simulationResultPage.reportBanner.mainImage[0].imageUrl',
                'simulationResultPage.reportBanner.mainImage[0].imageFile',
              ]}
              component={ImageField}
              width={828}
              height={182}
              maxWidth={414}
              maxHeight={91}
            />
          )}
          {device.value === 'padLandscape' && (
            <Field
              name="simulationResultPage.reportBanner.mainImage[2].imageFile"
              imageUrl={_get(
                formikProps.values,
                'simulationResultPage.reportBanner.mainImage[2].imageUrl'
              )}
              scaleImage={true}
              clearFormFields={[
                'simulationResultPage.reportBanner.mainImage[2].imageUrl',
                'simulationResultPage.reportBanner.mainImage[2].imageFile',
              ]}
              component={ImageField}
              width={3456}
              height={759}
              maxWidth={494}
              maxHeight={108}
            />
          )}
        </div>
      </div>
      <h4>
        <Trans i18nKey="p.s.uiconfiguration.simulationreport.treatment.descriptions">
          Treatment Descriptions
        </Trans>
        <div
          className="kt-margin-t-10"
          style={{
            backgroundColor: '#e1e1ef',
            height: '1px',
          }}
        />
      </h4>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.simulationreport.show.ideal.for">
            Show "Ideal For"
          </Trans>
        </label>
        <div className="col-9 col-lg-8 col-md-8 m-auto">
          <Field
            name="simulationResultPage.treatmentDescriptions.showIdealFor"
            value={_get(
              formikProps.values,
              'simulationResultPage.treatmentDescriptions.showIdealFor'
            )}
            component={CustomSwitch}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.simulationreport.treatment.name">
            Treatment Name
          </Trans>
        </label>
        <div className="col-4">
          <Select
            options={treatmentTypes}
            onChange={setTreatment}
            value={treatment}
            placeholder={
              <Trans i18nKey="c.c.select.placeholder">Select...</Trans>
            }
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.simulationreport.editing.language">
            Editing Language
          </Trans>
        </label>
        <div className="col-4">
          <Select
            options={langUtils.getAppLangList()}
            onChange={setLanguage}
            value={language}
            isSearchable={false}
            isClearable={false}
            placeholder={
              <Trans i18nKey="c.c.select.placeholder">Select...</Trans>
            }
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.simulationreport.treatment.description">
            Treatment Description
          </Trans>
          <span className="required">*</span>
        </label>
        <div className="col-9 col-lg-8 col-md-8">
          <Field
            name={`simulationResultPage.treatmentDescriptions.${_get(
              language,
              'value',
              'enu'
            )}.${_get(
              treatment,
              'value',
              'cheek_fillers'
            )}.treatmentDescription`}
            component={TextareaBox}
            style={{width: '100%'}}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.simulationreport.ideal.for">
            Ideal For
          </Trans>
        </label>
        <div className="col-9 col-lg-8 col-md-8">
          <Field
            name={`simulationResultPage.treatmentDescriptions.${_get(
              language,
              'value',
              'enu'
            )}.${_get(treatment, 'value', 'cheek_fillers')}.idealFor`}
            component={TextareaBox}
            style={{width: '100%'}}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.simulationreport.treatment.image">
            Treatment Image
          </Trans>
          <span className="required">*</span>
        </label>
        <div className="col-4 col-lg-4 col-md-4">
          <Field
            key={_get(treatment, 'value')}
            name={`simulationResultPage.treatmentImages[${_get(
              treatment,
              'value'
            )}].imageFile`}
            imageUrl={_get(
              formikProps.values,
              `simulationResultPage.treatmentImages[${_get(
                treatment,
                'value'
              )}].imageUrl`
            )}
            scaleImage={true}
            clearFormFields={[
              `simulationResultPage.treatmentImages[${_get(
                treatment,
                'value'
              )}].imageUrl`,
              `simulationResultPage.treatmentImages[${_get(
                treatment,
                'value'
              )}].imageFile`,
            ]}
            component={ImageField}
            imageFormat={'png'}
            width={724}
            height={724}
            maxWidth={181}
            maxHeight={181}
          />
        </div>
      </div>
    </>
  );
}
